module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJCAYAAAD6reaeAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAc0lEQVQI103MsQlCMQCE4S+SFUScIhtYWgUXsBBtJAO4gVhYC3GQvMLGHV7jNoJVJFf+d/dLtd1SbRtDFljjnWrb/uFc8hEPvHoReptqu+OEfRhdqbYPlnEAV6xwCMP1gjyXPMVU2xNn7OaSJ4j49kVX/QCHbCB3M+YrewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue.png
// module id = ghST
// module chunks = 1